<template>
  <div class="overall_situation" :class="$store.state.lang=='en-US'?'eng_situation':''">
    <!-- 导航栏 - S -->
    <nav class="ct-header navbar navbar-default navbar-fixed-top" v-if="IsShowSmallMenu==false">
      <!--glyphicon glyphicon-menu-hamburger -->
      <div class="container-fluid">
        <div class="row fluid_row">
            <div class="col-md-1 col-md-push-1" style="text-align:right;"> 
              <router-link to="/home">
              <div  class="logo-header" >
                <img src="../assets/images/logo_header.png" />
              </div>
              </router-link>
            </div>
            <div class="col-md-8  col-sm-10  col-xs-11" >
              <div class="nav-right" @mouseleave="leaveSecond()">
                <div class="nav-right-item" :class="active=='home'?'active':''"  @click="liJump('home','')">{{$t('NavabarText.navbar_home')}}</div>

                <div class="nav-right-item" :class="active=='about'||active=='honor'||active=='corporate'?'active':''" @click="liJump('about')" >
                  <span  >{{$t('NavabarText.navbar_about')}}</span>
                  <!-- <div class="dropdown" v-if="dropdownIndex=='about'">
                    <ul :class="$store.state.lang!='en-US'?'':'second_ul_special'">
                      <li @click="liJump('about','')" :class="active=='about'?'active':''">{{$t('NavabarText.navbr_child_about_1')}}</li>
                      <li @click="liJump('honor','')" :class="active=='honor'?'active':''">{{$t('NavabarText.navbr_child_about_2')}}</li>
                      <li @click="liJump('corporate','')" style="line-height:20px;!important" :class="active=='corporate'?'active':''">{{$t('NavabarText.navbr_child_about_3')}}</li>     
                    </ul>
                  </div> -->
                </div>
                
                <div class="nav-right-item" :class="active=='news'?'active':''" @click="liJump('news')"  >
                  <span >{{$t('NavabarText.navbr_new')}}</span>
                </div>
                <!-- <div class="nav-right-item" :class="active=='product'?'active':''"  @click="liJump('product','')">{{$t('NavabarText.navbar_product')}}</div> -->

                <div class="nav-right-item" :class="active=='cases'||active=='video'?'active':''"  @mouseover="mouseenter('cases','')">
                  <span  >{{$t('NavabarText.navbar_academic_trends')}}</span>
                  <div class="dropdown" v-if="dropdownIndex=='cases'">
                    <ul :class="$store.state.lang!='en-US'?'':'second_ul_special'">
                      <li @click="liJump('academicMeet')">{{$t('NavabarText.navbr_child_case_3')}}</li>
                      <li @click="openScan('')" :class="active=='cases'?'active':''">{{$t('NavabarText.navbr_child_case_1')}}</li>

                      <!-- <li @click="liJump('video','')" :class="active=='video'?'active':''">{{$t('NavabarText.navbr_child_case_2')}}</li> -->
                    </ul>
                  </div>
                </div>

                <div class="nav-right-item" :class="active=='responsibility'?'active':''"  @click="liJump('responsibility','')">{{$t('NavabarText.navbar_item')}}</div>
                <!-- <div class="nav-right-item" :class="active=='concept'?'active':''"  @click="liJump('concept','')">
                  <span  >{{$t('NavabarText.navbr_join')}}</span>
              
                </div> -->
                <!-- <div class="nav-right-item nav-right-button" :class="active=='concat'?'':''"  @click="liJump('concat','')">{{$t('NavabarText.navbar_contact')}}</div> -->
                
              </div>
            </div>
            <div class="col-md-2 lang_header">
              
                    <div class="lang-transfer" @click="langChangClick('zh-CN')">
                      <img src="../assets/images/cn.png" class="logo-headers"/>
                      <!-- <span class="lang">简</span> -->
                    </div>
                    <!-- <div class="lang-transfer" @click="langChangClick('zh-TCC')">
                      <img src="../assets/images/hk.png" class="logo-headers"/>
                      <span class="lang">繁</span>
                    </div> -->
                    <div class="lang-transfer" @click="langChangClick('en-US')">
                      <img src="../assets/images/en.png" class="logo-headers"/>
                      <!-- <span class="lang">Eng</span> -->
                    </div>
            </div>
        </div>
      </div>
    
      <!-- <el-row class="row row_header ">
          <el-col :span="2" ></el-col>
          <el-col :span="3" style="text-align:right;"> 
              <router-link to="/home">
                <img src="../assets/images/logo_header.png"  class="logo-header" />
              </router-link>
          </el-col>
          <el-col :span="14"  class="row_header_nav">
              <div class="nav-right">
                <div class="nav-right-item" :class="active=='home'?'active':''"  @click="liJump('home','')">{{$t('NavabarText.navbar_home')}}</div>
                <div class="nav-right-item" :class="active=='productCenter'?'active':''"  @click="liJump('','')">{{$t('NavabarText.navbar_product')}}</div>
                <div class="nav-right-item" :class="active=='caseCenter'?'active':''"  @click="liJump('','')">{{$t('NavabarText.navbar_academic_trends')}}</div>
                <div class="nav-right-item" :class="active=='serviceSupport'?'active':''"  @click="liJump('','')">{{$t('NavabarText.navbar_item')}}</div>
                <div class="nav-right-item" :class="active=='about'?'active':''" @mouseenter="mouseenter('about')" @mouseleave="leaveSecond()">
                  <span  @click="liJump('about','')">{{$t('NavabarText.navbar_about')}}</span>
                  <div v-if="dropdownIndex=='about'" class="dropdown">
                  
                    <ul :class="$store.state.lang!='en-US'?'':'second_ul_special'" >
                        <li @click="liJump('concat', '')">
                          <span>{{$t('NavabarText.navbar_contact')}}</span>
                        </li>
                    </ul>
                  </div>
                </div>
              </div>
          </el-col>
          <el-col :span="3" class="lang_header">
                    <div class="lang-transfer" @click="langChangClick('zh-TCC')">
                      <img src="../assets/images/hk.png" class="logo-headers"/>
                      <span class="lang">繁</span>
                    </div>
                    <div class="lang-transfer" @click="langChangClick('zh-CN')">
                      <img src="../assets/images/cn.png" class="logo-headers"/>
                      <span class="lang">简</span>
                    </div>
                    <div class="lang-transfer" @click="langChangClick('en-US')">
                      <img src="../assets/images/en.png" class="logo-headers"/>
                      <span class="lang">Eng</span>
                    </div>
          </el-col>
          
          <el-col :span="2" ></el-col>
      </el-row>   -->
    </nav>

    <nav class="ct-header navbar navbar-default navbar-fixed-top" v-if="IsShowSmallMenu==true">
      <!--glyphicon glyphicon-menu-hamburger -->
      <div class="container-fluid">
        <div class="row fluid_row">
          <div class="col-md-1 icon_menu"
               :class="IsShowMenu?'icon_menu_special':''">
            <i class="icon iconfont icon-caidan iconcaidan" @click="IsShowMenu=true"></i>
            <!-- <i class="icon iconfont iconcaidan "></i> -->
          </div>
          <div class="col-xs-7 col-md-9 header-logo"
               v-if="!IsShowMenu">
            <router-link to="/home">
              <img src="../assets/images/logo_header.png"
                   class="logo-header" />
            </router-link>
          </div>
        </div>
      </div>
      <!-- <div class="header-logo">
          <router-link to="/home">
            <img src="../assets/images/logo.png" class="logo-header"/>
          </router-link>
      </div> -->
      <div v-if="IsShowMenu"
           class="ct_dimback">
        <!-- <img src="../../static/images/memu_bg.png"
             style="width:100%; opacity:0.1; height:100vh;filter: alpha(opacity=60);" /> -->
             <span class="icon iconfont icon-caidan"></span>
        <div class="ct-content">
          <div class="href-ul">
            <div class="content_header">
              <div class="col-xs-3 col-md-1 close_icon">
                <i class="glyphicon glyphicon-remove icon_close"
                   @click="IsShowMenu=false"></i>
              </div>
              <!-- <div class="col-xs-6 col-md-9 white_logo"  @click="liJump('home')">
                <img src="../assets/images/logo_header.png" class="logo_header" />
              </div> -->
            </div>
            <ul class="nav nav-pills">
              <li>
                <a @click="liJump('about')" :class="active=='about'?'active':''">{{$t('NavabarText.navbar_about')}}</a>
              </li>
                <!-- <ul v-if="active=='about'" >
                       <li @click="liJump('about')">{{$t('NavabarText.navbr_child_about_1')}}</li>
                      <li @click="liJump('honor')">{{$t('NavabarText.navbr_child_about_2')}}</li>
                      <li @click="liJump('corporate')" style="line-height:20px;!important">{{$t('NavabarText.navbr_child_about_3')}}</li>
                </ul> -->
              <li>
                <a @click="liJump('news')" :class="active=='news'?'active':''">{{$t('NavabarText.navbr_new')}}</a>
              </li>
              <!-- <ul v-if="active=='news'" >
                    <li @click="liJump('company_news')">{{$t('NavabarText.navbr_child_news_1')}}</li>
                    <li @click="liJump('industry_news')">{{$t('NavabarText.navbr_child_news_2')}}</li>
              </ul> -->
              <li>
                <a @click="liJump('product')" :class="active=='product'?'active':''">{{$t('NavabarText.navbar_product')}}</a>
              </li>
                
              <li>
                <a @click="handleTabsClick('cases')" :class="active=='cases'||'video'?'active':''">{{$t('NavabarText.navbar_academic_trends')}}</a>
              </li>
              <ul v-if="active=='cases'" >
                    <!-- <li @click="liJump('academic')">{{$t('NavabarText.navbr_child_case_1')}}</li> -->
                     <li @click="openScan('small')">{{$t('NavabarText.navbr_child_case_1')}}</li>
                    <!-- <li @click="liJump('video')">{{$t('NavabarText.navbr_child_case_2')}}</li> -->
              </ul>
              <li>
                <a @click="liJump('responsibility')" :class="active=='responsibility'?'active':''">{{$t('NavabarText.navbar_item')}}</a>
              </li>

              <li>
                <a @click="liJump('concept')" :class="active=='concept'?'active':''">{{$t('NavabarText.navbr_join')}}</a>
              </li>
              <!-- <ul v-if="active=='join'" >
                  <li @click="liJump('concept')">{{$t('NavabarText.navbr_child_join_1')}}</li>
                  <li @click="liJump('recruitment')">{{$t('NavabarText.navbr_child_join_2')}}</li>
                  <li @click="liJump('development')">{{$t('NavabarText.navbr_child_join_3')}}</li>
              </ul> -->
              <li>
                <a @click="liJump('concat')" :class="active=='concat'?'active':''">{{$t('NavabarText.navbar_contact')}}</a>
              </li>
            </ul>
          </div>
          <div class="lang_flex">            
            <div class="lang-transfer lang-transfer-special"
                 @click="langChangClick('zh-CN')">
              <img src="../assets/images/cn.png"
                   class="logo-headers" />
              <span class="lang small-logo-headers"></span>
            </div>
            <!-- <div class="lang-transfer lang-transfer-special"
                 @click="langChangClick('zh-TCC')">
              <img src="../assets/images/hk.png"
                   class="logo-headers" />
              <span class="lang small-logo-headers">繁</span>
            </div> -->
            <div class="lang-transfer lang-transfer-special"
                 @click="langChangClick('en-US')">
              <img src="../assets/images/en.png"
                   class="logo-headers" />
              <span class="lang small-logo-headers"></span>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <!-- 导航栏 - E -->
    <!-- <div class="seat_div"></div> -->
    <div class="routerview"
         v-show="!IsShowMenu">
      <router-view></router-view>
    </div>
    <div class="foot-contact">
      <div class="foot-contact-content">
        <div class="contact-content-item">
          <div class="content-item-left-title">
            <div class="left-title-name">
              <span class="name-one">联系我们</span>
              <span class="name-two">/Contact Us</span>
            </div>
          </div>
          <div class="foot-item-child">
            <div class="icon iconfont icon-dianhua iconfontc"></div>
            <div class="child-item-content"><span>020-37247681</span></div>
          </div>
          <div class="foot-item-child">
            <div class="icon iconfont icon-daohangdizhi iconfontc"></div>
            <div class="child-item-content"><span>{{$t('footText.address_s')}}:{{$t('footText.address')}}</span></div>
          </div>
          
        </div>
        <!-- <div class="contact-content-item">
           <div class="wechat-div">
             <img src="../assets/images/index/weixin.png" class="wechat-img"/>
           </div>
        </div> -->
      </div>
    </div>
    <div class="foot-bottom-content">
      <div class="foot-bottom-content-info">
      <div class="foot-bottom-content-item">
        {{$t('footText.version')}}
      </div>
      <div class="foot-bottom-content-item">
        备案号： <span @click="beianClick">粤ICP备20041382号</span>
      </div>
      </div>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" :width="dialogWidth" class="customer_dialog" v-if="showLiveQRCode">
      <div class="scan_s">
        <img src="../assets/images/index/weixin.png"/>
      </div>
      <div class="scan_title" >扫描二维码，查看直播</div>
    </el-dialog>

    <el-dialog title="" :visible.sync="dialogVisible" :width="dialogWidth" class="customer_dialog_white" v-else>
      <div class="scan_s_s" >
        <img src="../assets/images/index/no_video.png"/>
      </div>
      <div class="scan_title">暂时还没有直播哦~</div>
    </el-dialog>
  </div>
</template>


<script type="text/javascript">
import {getLiveQrCode,getArticleTypeFirst,getArticleByTypeList} from '../service/service'
export default {
  metaInfo () {
    return {
      title: this.pageTitle
    }
  },
  data () {
    return {
      langText: this.$store.state.lang == 'en-US' ? 'en' : 'cn',
      active: 'home',
      dropdownIndex: '',
      dropdownSecondIndex: '',
      IsShowMenu: false,
      activityTwo: '',
      pageTitle: '广州市熵达贸易有限公司',
      IsShowSmallMenu:false,
      dialogVisible:false,
      dialogWidth:'30%',
      showLiveQRCode:false,
      companyData:[], 
      companyCode:'company_news',//公司资讯
      companyId:null,//公司资讯Id
      industryNewsCode:'industry_news',
      industryId:null,
    }
  },
  computed: {
    isEn: function () {
      return this.$store.state.lang == 'en-US'
    }
  },
  watch: {
    '$store.state.lang': function (nval, oval) {
      let obj = {
        'en-US': 'Guangzhou entropy Da Trade Co., Ltd',
        'zh-TCC': '廣州市熵達貿易有限公司',
        'zh-CN': '广州市熵达贸易有限公司'
      }
      this.pageTitle = obj[nval];
      console.log('jinlaile 进来了',this.pageTitle);
    },
    '$route.name':function(nval,oval){
      this.active=nval;
      console.log(nval,oval,'$route.name')
    },
    // 'companyId':function(nval,oval){
    //   if(nval!=0){
    //     this.getArticleByCompanyeList(1,2);
    //   }
    // },
    // 'industryId':function(nval,oval){
    //   if(nval!=0){
    //     this.getArticleByIndustryList(1,2);
    //   }
    // },
  },
  created(){
    this.getLiveQrCode();
    this.getArticleTypeFirst();
  },
  mounted () {
    //this.langText = this.$store.state.lang == 'en-US' ? 'English | 繁' : '繁 | English';
    console.log('window width:',document.body.clientWidth);

    let _path = this.$route.name
    this.active = _path;
    if(this.isMobileDevice()){
      this.IsShowSmallMenu=true;
    }else{
      this.IsShowSmallMenu=false;
       const that=this;
      window.onresize=()=>{
        return(()=>{
          let clientWidth=document.body.clientWidth;
          if(clientWidth<818){
            that.IsShowSmallMenu=true;
          }else{
            that.IsShowSmallMenu=false;
          }
        })()
      }
    }
   
   
  },
  methods: {
    async getArticleTypeFirst(){
      let resp=await getArticleTypeFirst('',1,999);
      if(resp){
        this.$store.commit('setArticleTypeData', resp.data);
        let ArticleTypeData=resp.data;
        console.log('jin:',ArticleTypeData)
        ArticleTypeData.map((v)=>{
          if(v.code==this.companyCode){
            this.companyId=v.id
          }else if(v.code==this.industryNewsCode){
            this.industryId=v.id
          }
        });
        this.$forceUpdate();
        console.log('setArticleTypeData',this.$store.state.ArticleTypeData)
        
        this.getArticleByCompanyeList(1,2);
      }
    },
    async getLiveQrCode(){
      let resp=await getLiveQrCode();
      if(resp){
        if(resp.state==1){
          this.showLiveQRCode=true;
        }else{
          this.showLiveQRCode=false;
        }
      }else{

      }
    },
    
    async getArticleByCompanyeList(pageNum,pageSize){
       let resp=await getArticleByTypeList(this.companyId,pageNum,pageSize);
       if(resp){
         this.companyData=[];
         resp.data.map((v)=>{
           let dateN=new Date(v.effectiveTime)
           v.year=dateN.getFullYear();
           v.month=dateN.getMonth()+1;
           v.month=v.month*1>9?v.month:'0'+v.month
           v.date=dateN.getDate();
           v.date=v.date*1>9?v.date:'0'+v.date
         })
         this.companyData=resp.data;
         this.getArticleByIndustryList(1,2);
       }
    },
    async getArticleByIndustryList(pageNum,pageSize){
       let resp=await getArticleByTypeList(this.industryId,pageNum,pageSize);
       if(resp){
         resp.data.map((v)=>{
           let dateN=new Date(v.effectiveTime)
           v.year=dateN.getFullYear();
           v.month=dateN.getMonth()+1; 
           v.month=v.month*1>9?v.month:'0'+v.month
           v.date=dateN.getDate();
           v.date=v.date*1>9?v.date:'0'+v.date
           this.companyData.push(v)
         })
         this.$store.commit('setCompanyData', this.companyData);
       }
    },
    openScan(val){
      if(val=="small"){
        this.dialogWidth="70%";
      }
      this.active='cases'
      console.log('进来了')
      this.dialogVisible=true;
    },
    beianClick(){
     window.open( 'https://beian.miit.gov.cn/')
       
      
    },
    langChangClick (lang) {
      this.$store.commit('setlang', lang);
      this.$i18n.locale = lang;
      if (lang == 'en-US') {
        $('#app').addClass('font_family');
        $('#app').removeClass('font_family_cn');
      } else {
        $('#app').addClass('font_family_cn');
        $('#app').removeClass('font_family');
      }
      this.IsShowMenu = false;
    },
    handleTabsClick (name) {
      if (this.active == name) {
        this.active = ''
      } else {
        this.active = name;
      }
      // this.active=name;
      // this.IsShowMenu=false;
      // this.$router.push({
      //   path: name
      // });
    },
    mouseenter (value) {
      this.dropdownIndex = value
    },
    leave () {
      this.$set(this, 'IsShowMenu', false)

    },
    mouseenterSecond (value) {
      this.dropdownSecondIndex = value
    },
    leaveSecond () {
      this.dropdownSecondIndex = ''
      this.dropdownIndex = ''
    },
    liJump (path, hash) {
      this.active = path;
      this.IsShowMenu = false;
    //   let _path = this.$route.name
    //   //if (path == _path) return
    //   console.log(path,this.pageTitle,this.langText)
      console.log(path,hash,'lijump');
      this.$router.push({
        path: path,
        hash: hash || ''
      })
    },
    liJumps (path) {
      this.$router.push({
        path: path
      })
    },
    isMobileDevice() {
        let isMobile = false;
        let thisOS = navigator.platform,
          userAgent = navigator.userAgent,
          appVersion = navigator.appVersion;
        let os = ["iPhone", "iPod", "iPad", "android", "Nokia", "SymbianOS", "Symbian", "Windows Phone", "Phone", "Linux armv71", "MAUI", "UNTRUSTED/1.0", "Windows CE", "BlackBerry", "IEMobile"];
        for (let i = 0; i < os.length; i++)
          if (thisOS.match(os[i]) || userAgent.match(os[i] || appVersion.match(os[i])))
            isMobile = true;

        //因为相当部分的手机系统不知道信息,这里是做临时性特殊辨认
        if (navigator.platform.indexOf('iPad') != -1)
          isMobile = true;

        //做这一部分是因为Android手机的内核也是Linux
        //但是navigator.platform显示信息不尽相同情况繁多,因此从浏览器下手，即用navigator.appVersion信息做判断
        if (appVersion.match(/linux/i))
        //X11是UC浏览器的平台 ，如果有其他特殊浏览器也可以附加上条件
          if (appVersion.match(/mobile/i) || appVersion.match(/X11/i))
            isMobile = true;

        return isMobile;
      },
  },
}

</script>

<style lang="scss" scoped>
.overall_situation{
  height: 100%;

}
.ct-header {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #ffffff;
  //z-index: 99999;
  margin-bottom: 0;
}
.container-fluid {
  width: 100%;
  margin: 0 0;
  .fluid_row {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 150px;
    box-shadow: 7px 7px 16px 0px rgba(19,36,51,0.08)  !important;
  }
  .nav-right{
    display:flex;
    justify-content: flex-end;
    align-items: center;
  }
  .nav-right-item{
    position: relative;
    font-size:21px;
    margin-right:35px;
    margin-left:35px;
    cursor:pointer;
    &:nth-child(1){
      margin-left:30px !important;
    }
    &:last-child{
      margin-right:0px;
    }

  }
  .nav-right-item:hover{
    color:#009fe9 !important;
  }
  .nav-right-item:active{
    color:#009fe9;
  }
  .nav-right-item:focus{
    color:#009fe9;
  }
  .nav-right-button{
    background:#4f7cbd;
    color:#ffffff;
    padding:10px 20px;
    border-radius:25px;

  }
}

.row_header{
  height: 160px;
  width:100%;
  padding:0 0 !important;
  margin:0 0 !important;
  display: flex;
  align-items: center;
}
.row_header_nav{
  // display: flex;
  // align-items: center;
  justify-content:space-between;
   .nav-right{
    display:flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
  }
  .nav-right-item{
    position: relative;
    font-size:20px;
    padding-right:30px;
    padding-left:25px;
    cursor:pointer;
    &:first-child{
      padding-left:0px !important;
    }
    &:last-child{
      margin-right:0px;
    }

  }
  .nav-right-item:hover{
    color:#009fe9;
  }
  .nav-right-item:active{
    color:#009fe9;
  }
  .nav-right-item:focus{
    color:#009fe9;
  }
   .nav-right-button{
    background:#4f7cbd;
    color:#ffffff;
    padding:10px 20px;
    border-radius:25px;
    
  }
}

 .lang_header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    // margin-left:30px;
    padding-left:45px;
  }

  .lang-transfer {
    display:flex;
    align-items:center;
    padding:0 5px;
    font-family: AlibabaPuHuiTi-Regular;
    font-size: 16px;
    font-stretch: normal;
    font-weight: 500;
    color: #3a3a3a;
    cursor: pointer;
    .lang{
      color:#3a3a3a;
      font-size:20px;
    }
  }

  .lang-transfer-special{
     font-size: 21px !important;
     .lang{
      color:#3a3a3a;
      font-size:24px;
    }
  }

  .lang-transfer span:hover {
    //  background-color: #009fe9!important;
    color: #00a0e9 !important;
  }

.s_li_content {
  & > li:first-child {
    margin-top: -20px;
  }
}
.icon_menu {
  position: absolute;
  display: flex;
  align-items: center;
  left: 20px;
  color: #009fe9;
  text-align: left;
}
.icon_menu_special {
  color: #fff;
}
.iconcaidan {
  font-size: 34px;
  border: 2px solid #009fe9;
  border-radius: 5px;
  padding: 2px 4px;
}

.logo-weixin {
  height: auto;
  width: 249px;
  height: 249px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.weixin-text {
  font-size: 28px;
  font-family: AlibabaPuHuiTi;
  font-weight: 500;
  color: #000000;
  margin-top: 18px;
}
.header-logo {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  position: relative;
  padding-left: 0px;
  // width: 476px;
  // height: 83px;
  box-sizing: border-box;
}
.ct_dimback {
  background: #354663;
  position: absolute;
  top: 0;
  z-index: 99999;
  width: 100%;
  filter: alpha(opacity=10);
  height: 100vh;
}
.ct-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  //background: url('/static/images/memu_bg.png') no-repeat;
  // background-size: 100% 100%;
  color: #fff;
  text-align: left;
  z-index: 999999;
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
}
.nav-pills {
  display: flex;
  flex-direction: column;
  color: #fff;
  margin-top: 6px;
}
.search-tip {
  margin-top: 10px;
  width: 100%;
  text-align: center;
  .search-btn {
    display: inline-block;
    width: 268px;
    height: 112px;
    line-height: 112px;
    background-color: #fff;
    border-radius: 60px;
    padding: 0px 40px;
    border: solid 1px #fff;
    text-decoration: none;
    font-family: MicrosoftYaHei;
    cursor: pointer;
    font-size: 30px;
    font-weight: bold;
    letter-spacing: 2px;
    color: #368da4;
    .iconsousuo {
      font-size: 30px;
      font-weight: bold;
    }
  }
}
.search-tip a:hover {
  background-color: #009fe9 !important;
  color: #fff;
}
.href-ul {
  width: 100%;
  height: 100%;
  z-index: 9999999;
  .content_header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    padding: 50px 0 40px 0;
    .close_icon {
      padding-left: 30px;
      font-size: 34px;
    }
  }
  .white_logo {
    height: auto;
    padding-left: 0px;

    .logo_header {
      width: 50%;
      height: auto;
    }
  }
}

.lang_flex {
  display: flex;
  text-align: center;
  margin: 50px 0 120px 0;
  .lang-transfer{
    margin-right:20px;
    &:last-child{
      margin-right: 0px !important;
    }
  }
}
// .lang-transfer {
//   padding: 0 28px;
//   font-size: 30px;
//   font-weight: 600;
//   font-stretch: normal;
//   letter-spacing: 0rem;
//   color: #fff;
//   cursor: pointer;
//   font-family: MicrosoftYaHei;
// }
.navbar-default {
  border-color: #ffffff !important;
}

.three-line {
  color: #009fe9;
  font-size: 2.5rem;
}

.dropdown-menu {
  min-width: 4rem !important;
}
.nav > li {
  margin-bottom: 30px;
}
.nav li a {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 35px;
  font-weight: bold;
  text-transform: none;
  font-stretch: normal;
  letter-spacing: 2px;
}
.dropdrow_a {
  position: relative;
}
.dropdrow_a:hover {
}
.xiala {
  margin-left: 1rem;
  font-size: 16px;
}
.xiangyou {
  font-size: 12px;
  color: #fff;
}
.second-ul {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.dropdown {
  position: absolute;
  // padding: 10px 25px;
  // background-color: #f5f5f5 !important;
  background-color: #ffffff;
	box-shadow: 0px 4px 18px 2px 
		rgba(79, 124, 189, 0.3);
  text-align: center;
  z-index: 9999999;
  border-radius: 10px ;
  // left: 174px;
  min-width: 150px;
  display: flex;
  justify-content: center;
  position: fixed;
  color: #fff;
  margin-left:-10px;
  margin-top:1px;
  padding-top:5px;
  ul {
    list-style: none;
    padding: 7px 0px;
    margin: 0;
    line-height: 27px;
    letter-spacing: 0.07em !important;
    color: #000;
    font-weight: 500;
    font-size: 20px;
  }
  ul li:hover{
    color: #4f7cbd;
	  background-color: #edf2f8;
  }
  li {
    padding: 10px 35px;
    cursor: pointer;
    
  }
  li {
    .active {
      color: #009fe9;
    }
  }
}

.dropdown ::before{
  content:'';
  position: absolute;
  top:-7px;
  left:65px;
  width:15px;
  height:15px;
  border:1px solid #ffffff;
  transform: rotate(45deg);
  border-right: transparent;
  border-bottom: transparent;
  background:#ffffff;
}
.second-ul {
}
.second-div {
  position: relative;
}
.dropdown-second {
  display: block;
  position: absolute;
  padding: 10px 20px;
  background-color: #009fe9;
  left: 100%;
  margin-left: 20px;
  min-width: 225px;
  top: -18px;
  overflow: visible;
  ul {
    list-style: none;
    padding: 7px 0;
    margin: 0;
    line-height: 27px;
    letter-spacing: 0.07em !important;
    color: #3b3b3b;
    font-weight: 400;
    font-size: 18px;
  }
  li {
    padding: 3px 0;
    cursor: pointer;
  }
  li:hover {
    color: #009fe9;
  }
}
.nav > li > a:focus,
.nav > li > a:hover {
  background: transparent;
}
.nav li {
  a.active {
    color: #009fe9 !important;
  }
}
.nav-pills li a {
  border-radius: 0;
}
.nav-pills > li + li {
  margin-left: 0;
}
.nav-pills ul {
  list-style: none;
  margin: 0;
  text-align: center;
  li {
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    padding-bottom: 45px;
    color: #ffffff;
  }
}
.active {
  color: #009fe9 !important;
}
// .nav li a:link{
//    background: #368da7;
//   color:#fff;
// }
.dropdown-menu li a {
  font-size: 1.2rem;
  letter-spacing: 0rem;
  color: #009fe9;
  font-weight: bold !important;
}

.dropdown-menu li a:active {
  color: #009fe9 !important;
}

.logo-header {
  // width: 100%;
  // height: auto;
  height: 120px;
  width:100%;
  display: flex;
  align-items: center;
  img{
    width:auto;
    height:60%;
  }
}

.logo-headers {
  width: 36px;
  height: 18px;
}
.lang {
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 28px;
  letter-spacing: 2px;
  color: #ffffff;
  margin-left: 6px;
}
.small-logo-headers{
  color:#ffffff !important;

}
.lang:hover {
  // color: #fff !important;
}
.seat_div {
  height: 179px;
  width: 100%;
}
.routerview {
  // padding-top: 179px;
  // background: #000000;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height:100%;
  overflow-y: auto;
  left: 0;
  right: 0;
  // top:160px;
  padding-top:150px;
  margin-bottom: 0px;
  min-height: 12.5rem;
}

.foot-bottom-content {
  width: 100%;
  padding: 40px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  background: #131416;
  position: relative;
  bottom: 0px;
  .foot-bottom-content-info{
    width:70%;
    margin:auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    .foot-bottom-content-item {
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      font-family: AlibabaPuHuiTi;
      font-weight: 400;
      color: #fff;
      margin-bottom:10px;
      cursor: pointer;
      //width:33.33%;
      a {
        color: #009fe9;
      }
    }
  }
  .cursor {
    cursor: pointer;
  }
  .cursor:hover {
    color: #9bd9dd;
  }
}
.foot_ul {
  text-align: left;
  margin-left: 27px;
  font-size: 24px;
  margin-bottom: 10px;
  li {
    list-style-type: none;
    margin-bottom: 15px;
    cursor: pointer;
  }
}



.level_prompt{
    // margin-top: 100px; 
    // width:280px; 
    // height:80px; 
    // position:relative;
    margin-top:9px;

}
.arrow{ 
    position:absolute; 
    width:48px; 
    height:48px; 
    bottom:20px; 
    left:10px; 
}
.arrow *{ 
    display:block;     
    border-width:18px 18px; 
    position:absolute; 
    border-style:solid dashed dashed dashed;
    // border-left: 50px solid transparent;
    // border-right: 50px solid transparent;
    // border-bottom: 100px solid red;
    font-size:0; 
    line-height:0; 
}
.arrow span{
    border-color:transparent  #f5f5f5 transparent transparent;
    top:0px; 
    left: 50px;
}



 .foot-contact{
   width:100%;
   background-color: #2e2d32;
   color:#666666;
   padding-top:98px;
   padding-bottom:48px;
   .foot-contact-content{
     width: 70%;
     margin:auto;
     display: flex;
     justify-content: space-between;
     align-items: center;
     flex-wrap: wrap;
     font-size: 20px;
     .contact-content-item{
       display: flex;
       justify-content: flex-start;
       align-items: flex-start;
       flex-direction: column;
       margin-bottom:28px;
       .contact-content-item:last-child{
         margin-bottom: 0px !important;
       }
       .content-item-left-title{
         width:456px;
         position:relative;
         display: flex;
         align-items: center;
         justify-content: flex-start;
         margin-bottom:10px;
         .left-title-name{
           color:#ffffff;
           .name-one{
             position:relative;
             font-size: 35px;
             font-weight: bold;
            cursor: pointer;
           }
           .name-one:after{
                content:" ";
                position:absolute;
                left:0;
                top:45px;
                bottom:0;
                width:50%;
                height:8px;
                transform:scaleY(.5);
                background-color:#666666;
            }
           .name-two{
             font-size: 21px;
             font-weight: bold;
             cursor: pointer;
           }
         }
       }
       .content-item-left-title:after{
          content:" ";
          position:absolute;
          left:0;
          bottom:0;
          width:100%;
          top:55px;
          height:1px;
          transform:scaleY(.5);
          background-color:#666666;
       }

       .foot-item-child{
         display: flex;
         justify-content: center;
         align-items: center;
         margin:0 0;
         padding:0 0;
         padding-top:20px;
          .iconfontc{
            padding:9px 8px;
            background-color: #3b3a3f;
            border-radius: 4px;
            font-size:23px;
            color:#9a999d;
          }
          .child-item-content{
            padding-left:22px;
            cursor: pointer;
            max-width: 500px;
            text-align: left;
          }

       }
       .wechat-div{

         .wechat-img{
           width: 273px;
	         height: 268px;
         }
       }
     }
   }
 }


.eng_situation{
  
  .container-fluid {
    width: 100%;
    margin: 0 0;
    .fluid_row {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 150px;
      box-shadow: 7px 7px 16px 0px rgba(19,36,51,0.08)  !important;
    }
    .nav-right{
      display:flex;
      justify-content: flex-end;
      align-items: center;
    }
    .nav-right-item{
      position: relative;
      font-size:18px;
      margin-right:20px;
      margin-left:20px;
      cursor:pointer;
      &:nth-child(1){
        margin-left:30px !important;
      }
      &:last-child{
        margin-right:0px;
      }

    }
    .nav-right-item:hover{
      color:#009fe9 !important;
    }
    .nav-right-item:active{
      color:#009fe9;
    }
    .nav-right-item:focus{
      color:#009fe9;
    }
    .nav-right-button{
      background:#4f7cbd;
      color:#ffffff;
      padding:10px 20px;
      border-radius:25px;

    }
  }

}


.customer_dialog .el-dialog{
  display: flex;
  .scan_s{
    width:288px;
    height: 288px;
    margin-top:20px;

  }
  .scan_s_s{
    // width:288px;
    // height: 288px;
    margin-top:20px;
    background: #ffffff;

  }
  img{
    width:100%;
    height: 100%;
  }
  .scan_title{
    margin-top:30px;
    margin-bottom:20px;
    font-size:28px;
    font-weight: bold;
    color:#ffffff;
  }
}

.customer_dialog_white .el-dialog{
  display: flex;
  .scan_s{
    width:288px;
    height: 288px;
    margin-top:20px;

  }
  .scan_s_s{
    // width:288px;
    // height: 288px;
    margin-top:20px;
    background: #ffffff;

  }
  img{
    width:100%;
    height: 100%;
  }
  .scan_title{
    margin-top:30px;
    margin-bottom:20px;
    font-size:28px;
    font-weight: bold;
    color:#999999;
  }
}


</style>

<style>
.tip_title .el-select {
   width:50% !important;
 }
 
.customer_video_dialog  .el-dialog{
  
   background: #333333  !important;
   padding:20px 20px;
}
.customer_dialog .el-dialog{ 
   background: #333333  !important;
   border-radius: 20px;
   display: flex;
   justify-content: center;
   align-items:center;
   color:#ffffff;
   flex-direction: column;
}
.customer_dialog_white .el-dialog{
   background: #ffffff  !important;
   border-radius: 20px;
   display: flex;
   justify-content: center;
   align-items:center;
   color:#ffffff;
   flex-direction: column;
}

.form_item_input .el-input__inner{
  width:100% !important;
  border: 0px solid #ffffff !important;
  border-radius: 0px !important;
  font-size: 18px !important;
}
 .form_item_input .el-select {
   width:100% !important;
 }

/* 超小屏幕（手机，小于 768px） */
/* 没有任何媒体查询相关的代码，因为这在 Bootstrap 中是默认的（还记得 Bootstrap 是移动设备优先的吗？） */

/* 小屏幕（平板，大于等于 768px） */
@media (min-width: @screen-sm-min) { 
    .nav-right-item{
     font-size:14px !important;
   }
}

/* 中等屏幕（桌面显示器，大于等于 992px） */
@media (min-width: @screen-md-min) { 

 }

/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media (min-width: @screen-lg-min) { 

}
/* @media (min-width:983px )  and (max-width:1181PX){

 .overall_situation .col-md-push-1{
    left:0% !important;
  }
  .overall_situation .col-md-1{
    width:0.66666667% !important;
  }
  
  .overall_situation .col-md-8{
    width:84.66666667% !important;
  }
   .overall_situation .col-md-2{
    width:11.66666667% !important;
  }
  .nav-right-item{
    margin-right:15px !important;
    margin-left:15px !important;
  }
  .lang_header{
    padding-left:2px !important;
    
  }

} */
@media (max-width: 768px){
  .product_contents .product_title{
      font-size:30px !important;
  }
  .product_contents .product_line_left{
    margin-right:18px !important;
    width: 180px !important;
  }
  .product_contents  .product_line_right{
    margin-left:18px !important;
    width: 180px !important;
  }

  .product_center_info .product_type{
        flex-wrap: wrap;
  }
  .product_center_info .product_type .type_item{
      padding:8px 15px !important;
      font-size: 16px !important;
      margin-left:15px !important;
      margin-bottom:10px;
  }
  .product_center_info .product_type .type_item_active{
             
     border-radius: 25px !important;
  }
  .product_detail_info{
    width:70% !important;
    flex-wrap: wrap !important;
  }
  .product_detail_info .detail_item{
      margin-left:0px !important;
  }
  .concat_info{
    flex-wrap: wrap !important;
  }

  .honor_detail{
    flex-wrap: wrap !important;
    justify-content: center !important;
  }
  .process_content .process_item:first-child{
    margin-left :0px !important;
    padding-left :0px !important;
  }
  .process_content .process_item:first-child::after{
    width:120% !important;
    left:50%  !important;
   
  }
  .honor_content{
    width:90% !important;
    padding-bottom:0px !important;
  }
  .honor_process_content{
    width:100% !important;
  }
  .honor_process_contents{
    width:100% !important;
  }
  .honor_item_img{
      margin-bottom:40px;
      margin-top:40px;
      margin-right:0px !important;
  }
  .process_content .process_item{
     width:300px !important;
  }
    
  .honor_process_contents .process_content .process_item::after{
    width:105% !important;
    left:65%  !important;
   
  }

   .company_culture_content{
        width:80% !important;
    }
    .company_culture_content .company_content_culture{
        flex-wrap: wrap !important;
    }
    .company_culture_content .company_content_culture .culture_item{
     margin-bottom:20px;
    }
  

  
  .responsibility_c .responsibility_content .responsibility_info .info_img_content{
    flex-wrap: wrap !important;
  }
  .responsibility_c .responsibility_content .responsibility_info .info_img_content .img_item{
    margin-right:  0px !important;
  }

  .responsibility_c .responsibility_content .responsibility_info .info_img_content_in{
    flex-wrap: wrap !important;
  }
  .responsibility_c .responsibility_content .responsibility_info .info_img_content_in .img_item{
    margin-right:  0px !important;
  }

  .video_desc .desc_dates{
    display: block !important;
    text-align: left !important;

  }
  .video_desc .desc_dates .hostipal{
    margin-left: 0px !important;
    
  }
  .video_desc .desc_dates .dates{
    margin-left: 0px !important;
    
  }
   

   
  .personnel_recruit{
    flex-wrap:wrap !important;

  }

  .personnel_recruit .person_item{
    width: 387px !important;
    margin-left:0px !important;
  }



}
@media (max-width:900px) {
    .product_contents{
      width:100% !important;
    }
   .news_info .news_content{
    flex-wrap: wrap  !important;
  }
  .news_info .news_content .news_img {
  margin-bottom: 20px !important;
  }
}
@media (max-width: 750px){
  
  .routerview{
  padding-top:120px !important;
  }
  /* .ct-header{
    width:1200px !important;
  } */
  .fluid_row{
    height: 120px !important;
  }
  /* .routerview{
    top:120px !important;
  } */
  .logo-header{
    width:100%;
    height: 60px !important;
  }
  .nav-right-item{
     font-size:20px !important;
     margin-left:15px !important;
     margin-right: 15px !important;
  }
  
  .lang_header{
    margin-left:10px !important;
  }
  .foot-contact-content{
    width:60% !important;
    /* justify-content: center !important; */
  }

  .foot-bottom-content{
  
  }
  .foot-bottom-content .foot-bottom-content-info {
    width:70% !important;
    justify-content: center !important;
  }

   .company_introd_info {
        width:80% !important;
   }
   .company_introd_info .company_introd_detail .detail_content{
     flex-wrap: wrap !important;
     align-items: left !important;
     justify-content: left !important;
   }
        
   .company_introd_info .company_introd_detail .detail_content .item_c{
     padding-left:0px !important;

   }
}
@media (min-width: 848px) and (max-width: 850px){
  /* .overall_situation .col-md-8{
    width: 66.66666667%  !important;
  }
  .eng_situation .col-md-8{
    width: 86.66666667%  !important;
  } */

   .eng_situation .col-md-1{
    /* width:0.8% !important; */
    display: none;
  }
  
}
@media (min-width: 992px){
  /* .overall_situation .col-md-8{
    width: 66.66666667%  !important;
  }
  .eng_situation .col-md-8{
    width: 86.66666667%  !important;
  } */

  /* .eng_situation .col-md-push-1{
    left:0% !important;
  }
   .eng_situation .col-md-1{
    width:0.8% !important;
  
  }
  
  .eng_situation .col-md-8{
    width:93.66666667% !important;
  }
   .eng_situation .col-md-2{
    width:11.66666667% !important;
  } */
  .eng_situation .col-md-8{
    width:80.66666667% !important;
  }
}
@media (min-width: 750px) and (max-width: 860px){
 .fluid_row{
   height: 150px !important;
 }
 
  /* .routerview{
    top:140px !important;
  } */
  .nav-right-item{
     font-size:20px !important;
     margin-left:15px !important;
     margin-right: 15px !important;
  }
}
@media (min-width: 860px) and (max-width:1200px){
  
  .fluid_row{
    height: 150px !important;
  }
  
  .routerview{
    /* top:150px !important; */
  }
  .overall_situation .nav-right-item{
     font-size:20px !important;
     margin-left:20px !important;
     margin-right: 20px !important;
  }
  .lang_header{
    margin-left:10px !important;
  }
  
  .eng_situation .nav-right-item{
     font-size:20px !important;
     margin-left:10px !important;
     margin-right: 10px !important;
  }
   /* .eng_situation .overall_situation .col-md-push-1{
    left:0% !important;
  }
   .eng_situation .overall_situation .col-md-1{
    width:1.66666667% !important;
  }
  
   .eng_situation .overall_situation .col-md-8{
    width:88.66666667% !important;
  }
   .eng_situation  .overall_situation .col-md-2{
    width:11.66666667% !important;
  } */
}
@media (min-width: 974px) and (max-width: 1000px){                  
  
  
  .eng_situation .nav-right-item{
     font-size:18px !important;
     margin-left:10px !important;
     margin-right: 10px !important;
  }
}
@media (min-width: 1300px) and (min-width: 1379px){                  
  
  
  .eng_situation .nav-right-item{
     font-size:18px !important;
     margin-left:20px !important;
     margin-right: 20px !important;
  }
}
@media (min-width: 1380px){                  
  
  .fluid_row{
    height: 150px !important;
  }
  
  .routerview{
    /* top:150px !important; */
  }
  .overall_situation .nav-right-item{
     font-size:22px !important;
     margin-left:25px !important;
     margin-right: 25px !important;
  }
  .lang_header{
    margin-left:20px !important;
  }
  .eng_situation .nav-right-item{
     font-size:18px !important;
     margin-left:30px !important;
     margin-right: 30px !important;
  }
}
@media (min-width: 1400px){                  
  
  .foot-contact-content{
    width:60% !important;
  }
 
}
@media (min-width: 1500px){                  
  
  .left_menus{
    left:10% !important;
  }
  .product_detail_info{
    width:60% !important;
  }

  .product_center .product_center_info .product_type{
      width:50% !important;
  }


  
  .process_content .process_item:first-child{
    margin-left :0px !important;
    padding-left :0px !important;
  }
  .process_content .process_item:first-child::after{
    width:120% !important;
    left:50%  !important;
   
  }
  .honor_content{
    width:80% !important;
    padding-bottom:0px !important;
  }
  .honor_process_content{
    width:100% !important;
  }
  .honor_process_contents{
    width:100% !important;
  }
  .honor_item_img{
      margin-bottom:40px;
      margin-top:40px;
      margin-right:0px !important;
  }
  .process_content .process_item{
     width:300px !important;
  }
    
  .honor_process_contents .process_content .process_item::after{
    width:102% !important;
    left:55%  !important;
   
  }


}
@media (min-width:700px )  and (max-width:1542px){
  .overall_situation .col-md-push-1{
    left:1% !important;
  }
}
@media (min-width:1000px )  and (max-width:1182PX){

 .overall_situation .col-md-push-1{
    left:7% !important;
  }
  .overall_situation .col-md-1{
    width:1.66666667% !important;
  }
  
  .overall_situation .col-md-8{
    width:84.66666667% !important;
  }
   .overall_situation .col-md-2{
    width:11.66666667% !important;
  }
  .overall_situation .nav-right-item{
    margin-right:15px !important;
    margin-left:15px !important;
  }
  .eng_situation .container-fluid .nav-right-item{
    margin-right:12px !important;
    margin-left:12px !important;
  }
  .eng_situation .col-md-1{
    width:0.8% !important;
  }
  
  .eng_situation .col-md-8{
    width:93.66666667% !important;
  }
   .eng_situation .col-md-2{
    width:6.66666667% !important;
  }

  
  .lang_header{
    padding-left:2px !important;
    
  }
  .eng_situation .nav-right-item{
    margin-right:10px !important;
    margin-left:10px !important;
  }
  /* .logo-header{
    width:95% !important;
  } */
}
@media (min-width:1000px )  and (max-width:1426px){

  .overall_situation .col-md-1{
    width:9.66666667% !important;
  }
}

@media (min-width:1200px )  and (max-width:1272px){

 .overall_situation .col-md-push-1{
    left:4.3% !important;
  }
  .overall_situation .col-md-1{
    width:2.66666667% !important;
  }
  
  .overall_situation .col-md-8{
    width:80.66666667% !important;
  }
   .overall_situation .col-md-2{
    width:12.66666667% !important;
  }
}
@media (min-width:1200px )  and (max-width:1242px) {
  .overall_situation .nav-right-item{
    margin-right:25px !important;
    margin-left:25px !important;
  }
  .eng_situation  .nav-right-item{
    margin-right:12px !important;
    margin-left:12px !important;
  }
}
@media (min-width:1243px )  and (max-width:1282px) {
  .overall_situation .nav-right-item{
    margin-right:25px !important;
    margin-left:25px !important;
  }
  .eng_situation .container-fluid .nav-right-item{
    margin-right:12px !important;
    margin-left:12px !important;
  }
}
@media (min-width:1416px )  and (max-width:1542px){
  .overall_situation .col-md-push-1{
    left:1% !important;
  }
 
  .overall_situation .col-md-1{
    width:16.66666667% !important;
  }
}
@media (min-width:1273px )  and (max-width:1311px){

  .overall_situation .col-md-1{
    width:8.66666667% !important;
  }
  
  .overall_situation .col-md-8{
    width:81.66666667% !important;
  }
   .overall_situation .col-md-2{
    width:11.66666667% !important;
  }
}
@media (min-width:1312px )  and (max-width:1415px){

  .overall_situation .col-md-1{
    width:12.66666667% !important;
  }
  
  .overall_situation .col-md-8{
    width:75.66666667% !important;
  }
   .overall_situation .col-md-2{
    width:11.66666667% !important;
  }
}
@media (min-width:1543px )  and (max-width:1690px){
  .overall_situation .col-md-push-1{
    left:5% !important;
  }
}



@media (min-width: 1080px) and (max-width: 1334px){
  .product_detail_info{
    width:80% !important;
  }
}

@media (min-width: 800px) and (max-width: 960px){
  .product_detail_info{
    width:90% !important;
  }
  .detail_item:nth-child(3n+1){
    
    margin-left:18px !important;
                
  }
  .detail_item:nth-child(2n+1){
    
    margin-left:0px !important;
                
  }

}
@media (min-width: 961px) and (max-width: 1100px){
  .product_detail_info{
    width:70% !important;
  }
  .detail_item:nth-child(3n+1){
    
    margin-left:18px !important;
                
  }
  .detail_item:nth-child(2n+1){
    
    margin-left:0px !important;
                
  }
  

}
@media (max-width: 1080px) {
   .company_introd_info {
        width:70% !important;
   }
   .company_introd_info .company_introd_detail .detail_content{
     flex-wrap: wrap !important;
     align-items: center !important;
     justify-content: center !important;
   }
        
   .company_introd_info .company_introd_detail .detail_content .item_c{
     padding-left:0px !important;

   }

   .company_environment .company_environment_content{
      width:80% !important;
   }
   .company_environment .company_environment_content .company_env_show{
    /* flex-wrap: wrap !important;
    justify-content: flex-start !important; */

   }
     
    
}
@media (max-width: 1080px) {
  

   .company_environment .company_environment_content{
      width:80% !important;
   }
   .company_environment .company_environment_content .company_env_show{
    flex-wrap: wrap !important;
    justify-content: space-between !important;
    align-items: center  !important;


   }
   .company_environment .company_environment_content .company_env_show .show_item{
    padding-left: 0px !important;
    

   }
   .company_environment .company_environment_content .company_env_show .show_item .item_show_img{
      width:350px !important;
   }
  .honor_detail{
    flex-wrap: wrap !important;
    justify-content: center !important;
  }
  .process_content .process_item:first-child{
    margin-left :0px !important;
    padding-left :0px !important;
  }
  .process_content .process_item:first-child::after{
    width:120% !important;
    left:50%  !important;
   
  }
  .honor_content{
    width:80% !important;
    /* padding-bottom:0px !important; */
  }
  .honor_process_content{
    width:90% !important;
  }
  .honor_process_contents{
    width:90% !important;
  }
  .honor_item_img{
      margin-bottom:40px;
      margin-top:40px;
      margin-right:0px !important;
  }
  .process_content .process_item{
     width:300px !important;
  }
    
  .honor_process_contents .process_content .process_item::after{
    width:105% !important;
    left:60%  !important;
   
  }

}

@media (min-width: 1800px) {
  .left_menus{
    left:15% !important;
  }
}

@media (max-width: 900px) {
  .left_menus_position_r{
    top:15% !important;
  }
  .left_menus{
    left:0 !important;
  }
  .left_menus_r{
    left:0px !important;
  }
  .left_menus_r .menus_contents{
    width:150px !important;
  }
  
  .left_menus .menus_contents{
    width:100px !important;
    text-align: left;
  }
  .left_menus .menus_contents .memus_item{
    padding-left:10px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue